var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55.5,
    height: 16.88,
    viewBox: "0 0 55.5 16.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_215",
    "data-name": "Ret\\xE2ngulo 215",
    width: 55.5,
    height: 16.88,
    fill: "#"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_304",
    "data-name": "Grupo 304",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_303",
    "data-name": "Grupo 303",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_450",
    "data-name": "Caminho 450",
    d: "M54.973,6.989a1.733,1.733,0,0,1-2.451,2.451l-2.007-2-2,2A1.733,1.733,0,1,1,46.03,7.02l.031-.031,2-2-2-2A1.734,1.734,0,0,1,48.47.486l.042.045,2,2,2.007-2a1.732,1.732,0,1,1,2.492,2.406l-.042.045-2.007,2Zm-1.227,6.426H47.285a1.733,1.733,0,1,0,0,3.466h6.461a1.733,1.733,0,1,0,0-3.466M39.794.528a1.734,1.734,0,0,0-2.451,0L35.337,2.535l-2-2.007a1.733,1.733,0,0,0-2.451,2.451l2,2.007-2,2a1.733,1.733,0,0,0,2.451,2.451l2-2,2.007,2A1.733,1.733,0,1,0,39.826,7.02l-.031-.031-2.007-2,2.007-2a1.738,1.738,0,0,0,0-2.454M38.567,13.415H32.11a1.733,1.733,0,1,0,0,3.466h6.457a1.733,1.733,0,1,0,0-3.466M24.616.528a1.734,1.734,0,0,0-2.451,0l-2,2.007-2-2.007a1.734,1.734,0,0,0-2.5,2.409l.045.042,2,2.007-2,2a1.733,1.733,0,0,0,2.451,2.451l2-2,2,2a1.733,1.733,0,0,0,2.451-2.451l-2-2,2-2a1.732,1.732,0,0,0,0-2.454M23.393,13.415H16.932a1.733,1.733,0,0,0,0,3.466h6.461a1.733,1.733,0,1,0,0-3.466M9.441.528a1.738,1.738,0,0,0-2.454,0l-2,2.007L2.98.528a1.734,1.734,0,0,0-2.5,2.409l.045.042,2,2.007-2,2A1.733,1.733,0,0,0,2.98,9.439l2-2,2.007,2A1.733,1.733,0,0,0,9.441,6.989l-2.007-2,2.007-2A1.738,1.738,0,0,0,9.441.528ZM8.214,13.415H1.753a1.733,1.733,0,0,0,0,3.466H8.214a1.733,1.733,0,0,0,0-3.466",
    transform: "translate(0 -0.002)",
    fill: "#"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPassword);
export default __webpack_public_path__ + "static/media/IconPassword.f65356883ca82becb150f5d6950813bd.svg";
export { ForwardRef as ReactComponent };